import { Accordion } from '@mantine/core';

function VersionList() {

  const groceries = [
    {
      value: 'Versió 3.8.',
      description:
        'S\'afegeixen noves funcionalitats. S\'apliquen nous dissenys i usabilitat',
    },
    {
      value: 'Versió 3.7.',
      description:
        'S\'afegeixen noves funcionalitats. S\'aplica l\'implementació de SEO a la web.',
    },
    {
      value: 'Versió 3.6',
      description:
        'S\'afegeixen noves funcionalitats. Inclou la possibilitat de buscar fonts accessibles.',
    },
    {
      value: 'Versió 3.5',
      description:
        'Es presenta aquesta aplicació! ',
    },


  ];

  const items = groceries.map((item) => (
    <Accordion.Item key={item.value} value={item.value}>
      <Accordion.Control>{item.value}</Accordion.Control>
      <Accordion.Panel>{item.description}</Accordion.Panel>
    </Accordion.Item>
  ));

  return (
    <Accordion  radius="xl"  >
      {items}
    </Accordion>
  );
}
export default VersionList;